import './appLayout.scss';
import React, { useState, useEffect, memo, useRef } from 'react';
import { Tabs, NavBar, Icon } from 'antd-mobile';
import { getPlatConfig, getBooleanValue, setApp, getPageQuery } from '../utils';
import { getNavs, getCmsAppInfo, getCmpts, detail } from '../services/saas/app';
import { useHistory } from 'react-router';
import TscloudActiveList from '../busi/tscloud/activeList';
import TscloudActiveLive from '../busi/tscloud/activeLive';

import SassActiveList from '../busi/saas/activeList';
import SassActiveLive from '../busi/saas/activeLive';
import SassConferenceList from '@/busi/saas/conferenceList';
import SassLiveChannelList from '@/busi/saas/liveChannelList';
import SassDeptList from '@/busi/saas/prestigiousSchool';
import SassResList from '../busi/saas/res';
import DrawerWrapper from '@/components/drawerWrapper';
import SassSchedule from '@/busi/saas/schedule';
import SaasActiveCalendar from '@/busi/saas/activeCalendar';
import Studio from '@/busi/saas/studio';

import OaNav from '@/busi/saas/oa/oaNav';
import OaImg from '@/busi/saas/oa/oaImg';

import TimeTable from '@/pages/manage/timeTable';
function renderCmpt(key, config) {
  let cmpt = null;
  switch (key) {
    case 'hdlbTscloud':
      cmpt = <TscloudActiveList config={config} />;
      break;
    case 'hdzbTscloud':
      cmpt = <TscloudActiveLive config={config} />;
      break;
    case 'hdlb':
      cmpt = <SassActiveList config={config} />;
      break;
    case 'hdzb':
      cmpt = <SassActiveLive config={config} />;
      break;
    case 'conferenceList':
      cmpt = <SassConferenceList config={config} />;
      break;
    case 'liveChannelList':
      cmpt = <SassLiveChannelList config={config} />;
      break;
    case 'mxlb':
      cmpt = <SassDeptList config={config} />;
      break;
    case 'zyzx':
      cmpt = <SassResList config={config} />;
      break;
    case 'schedule':
      cmpt = <SassSchedule config={config} />;
      break;
    case 'activeCalendar':
      cmpt = <SaasActiveCalendar config={config} />;
      break;
    case 'oaNav':
      cmpt = <OaNav config={config} />;
      break;
    case 'oaImg':
      cmpt = <OaImg config={config} />;
      break;
    case 'padManage':
      cmpt = <TimeTable config={config} />;
      break;
    case 'studio':
      cmpt = <Studio config={config} />;
      break;
    default:
      break;
  }
  return cmpt;
}

function AppLayout(props) {
  const {
    match: {
      params: { appCode },
    },
  } = props;
  const { platformType } = getPlatConfig() || {};
  const [tabList, setTabList] = useState([]);
  const [cmptList, setCmptList] = useState([]);
  const [appId, setAppId] = useState();
  const [appName, setAppName] = useState('');
  const storeRef = useRef({ selected: undefined });
  const history = useHistory();
  const page = 4;
  const maxLength = tabList.length > page ? page : tabList.length;
  const width = ((100 / maxLength) * 0.47).toFixed(3);
  const left = (100 / maxLength).toFixed(3);
  const { navCode: navCodeParam } = getPageQuery() || {};

  const getSaasCmptList = async function (appId, navCode) {
    const respCmpt = await getCmpts({
      appId,
      moduleKey: 'CONTENT',
      navCode,
    });
    if (respCmpt.success && respCmpt.data) {
      setCmptList(
        respCmpt.data.map((item) => ({
          key: item.moduleCmptId,
          cmptCode: item.componentKey,
          config: item.componentPara ? JSON.parse(item.componentPara) : {},
        })),
      );
    }
  };

  const getTscloudCmptList = async function (code) {
    setCmptList([{ key: code, cmptCode: code }]);
  };

  const getSassCmpt = async function (appNo) {
    const respApp = await getCmsAppInfo({ appNo, cmsTerminalType: 'h5' });
    if (respApp.success && respApp.data) {
      const respNavs = await getNavs({
        appId: respApp.data.appId,
      });
      setAppId(respApp.data.appId);
      if (respNavs.success && respNavs.data) {
        setTabList(respNavs.data.map((item) => ({ title: item.navName, key: item.navCode })));
        if (respNavs.data.length > 0) {
          const defaultSelected = navCodeParam || respNavs.data[0].navCode;
          storeRef.current.selected = defaultSelected
          getSaasCmptList(respApp.data.appId, defaultSelected);
        }
      }
    }
  };

  const getTscloudCmpt = async function () {
    await setTabList([
      { title: '活动列表', key: 'hdlbTscloud' },
      { title: '活动直播', key: 'hdzbTscloud' },
    ]);
    storeRef.current.selected = 'hdlbTscloud';
    getTscloudCmptList('hdlbTscloud');
  };

  const getAppInfo = async () => {
    const respApp = await detail({ appCode });
    if (respApp.success && respApp.data) {
      setApp(respApp.data);
      setAppName(respApp.data.appName);
      return respApp.data.appH5Url.split(':')[1];
    }
  };

  const initSaas = async () => {
    const h5CmsAppCode = await getAppInfo();
    getSassCmpt(h5CmsAppCode);
  };

  useEffect(() => {
    if (platformType === 'saas') {
      initSaas();
    } else if (platformType === 'tscloud') {
      getTscloudCmpt();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DrawerWrapper>
      <div className={`app-layout${getBooleanValue('IS_IMMERSE', false) ? ' immerse' : ''}`}>
        <NavBar mode="light" icon={<Icon type="left" />} onLeftClick={() => history.goBack()}>
          {appName}
        </NavBar>
        <div className="app-tabs">
          <Tabs
            tabs={tabList}
            tabBarPosition="top"
            swipeable={false}
            renderTabBar={
              tabList.length > 1 ? (props) => <Tabs.DefaultTabBar {...props} page={page} /> : false
            }
            page={storeRef.current.selected}
            tabBarUnderlineStyle={{
              width: `${width}vw`,
              height: '0.667vw',
              marginLeft: `calc((${left}% - ${width}vw) / 2)`,
              backgroundColor: '#00b4ff',
              borderRadius: '0.333vw',
            }}
            onChange={async (tab) => {
              storeRef.current.selected = tab.key;
              if (platformType === 'saas') {
                getSaasCmptList(appId, tab.key);
              } else if (platformType === 'tscloud') {
                getTscloudCmptList(tab.key);
              }
            }}
          >
            {storeRef.current.selected && tabList.map((item) => (
              <div key={item.key} style={{ height: '100%' }}>
                {storeRef.current.selected === item.key
                  ? cmptList.map((item) => (
                      <div key={item.key} style={{ height: '100%' }}>
                        {renderCmpt(item.cmptCode, item.config)}
                      </div>
                    ))
                  : null}
              </div>
            ))}
          </Tabs>
        </div>
      </div>
    </DrawerWrapper>
  );
}

export default memo(AppLayout);
